const { utils: { getCookieByName } } = window.__haftahave;
const debug = Boolean(getCookieByName('__hh_debug'));
const testNumber = getCookieByName('__hh_number');

debug && console.log('!!!START');
debug && console.log('!!!NUMBER=', testNumber);
(() => {
    debug && console.log('!!!BEGIN');
    const url = new URL(document.location.href);

    if (url.pathname !== '/checkout/') {
        debug && console.log('!!!NOT CHECKOUT');
        return;
    }

    const { form } = document.getElementById('place_order');

    const getPhoneNumber = () => {
        const element = document.getElementById('billing_phone');
        return element.value;
    };
    const sendRequest = (phone, domain) => {
        debug && console.log('sendRequest()');
        const params = {
            type: 'customer_phone',
            data: {
                customerPhone: phone,
                domain,
            },
        };

        // send event to api gateway
        const xhr = new XMLHttpRequest();
        xhr.open('POST', process.env.HH_AWS_API_GATEWAY_TRACKING, true);
        xhr.setRequestHeader('Content-type', 'application/json');
        xhr.send(JSON.stringify(params));
    };

    const submitHandler = () => {
        debug && console.log('submitHandler()');
        const phone = getPhoneNumber() || null;

        const hasPhone = Boolean(phone && phone === testNumber);
        if (hasPhone) {
            form.removeEventListener('submit', submitHandler);
            sendRequest(phone, url.origin);
        }
    };

    form.addEventListener('submit', submitHandler);
    debug && console.log('!!!END');
})();
debug && console.log('!!!FINISH');
